export default function IdleTycoonIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="6" y="40" width="10" height="18" rx="2" fill="#2f8bff" />
      <rect x="20" y="30" width="10" height="28" rx="2" fill="#59d98e" />
      <rect x="34" y="20" width="10" height="38" rx="2" fill="#ffd84d" />
      <path d="M6 34L22 22l10 6L52 8" stroke="#ff8a1f" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M44 7h9v9" stroke="#ff8a1f" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="51" cy="46" r="11" fill="#ffd84d" stroke="#c99200" strokeWidth="3" />
      <text x="51" y="51.5" textAnchor="middle" fontSize="15" fontWeight="900" fill="#7a5600" fontFamily="system-ui, sans-serif">$</text>
    </svg>
  );
}
